<sh-dropdown
    #dropdown
    [label]="label()"
    [value]="displayValue()"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [attr.no-border]="noBorder() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
    (active-changed)="handleActiveChanged($event)"
    (clear-clicked)="handleClear()"
>
    <!--
        Results are fully driven by Angular. The selected user is shown as the
        field value (a bound signal) and highlighted here when present in the
        list. We intentionally do NOT mark it as a SHUI `active` item, since
        that makes the dropdown reassert the selected label into the input and
        snap back over an in-progress search.
    -->
    @if (searchResults().length > 0) {
        @for (user of searchResults(); track user.gid) {
            <sh-menu-item
                [class.selected]="isUserActive(user.gid)"
                [attr.data-testid]="optionTestId() ? optionTestId() + '-' + user.gid : null"
                [label]="getUserDisplayName(user)"
                [value]="user.gid"
                (click)="handleUserSelect(user)"
            ></sh-menu-item>
        }
    } @else if (!isLoading()) {
        <sh-menu-item label="No users found" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
